module.exports = __webpack_public_path__ + "static/media/giraffe.645f43d2.png";